export default __webpack_public_path__ + "static/media/IconDelete.f276df00.svg";